import { useEffect, useState } from "react";

import { apiClient } from "../../api/client";
import type { LeaderboardEntry, LeaderboardResponse } from "../../api/types";
import { useAuth } from "../../context/AuthContext";

const BADGE_BY_RANK: Record<number, string> = {
  1: "👑",
  2: "🥇",
  3: "🥈",
};

export function LeaderboardPage() {
  const { user } = useAuth();
  const [entries, setEntries] = useState<LeaderboardEntry[]>([]);
  const [loading, setLoading] = useState(true);

  const myHandle = user?.handle.toLowerCase();

  useEffect(() => {
    void apiClient
      .get<LeaderboardResponse>("/leaderboard?city=cincinnati&period=week")
      .then((res) => setEntries(res.entries))
      .catch(() => setEntries([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main className="page-shell owls-page">
      <header className="owls-header">
        <h1>Top Contributors</h1>
        <p>Most helpful this week</p>
      </header>

      {loading ? (
        <div className="empty-state"><p>Loading…</p></div>
      ) : entries.length === 0 ? (
        <div className="empty-state">
          <p>No contributions yet this week.</p>
          <p style={{ marginTop: "8px" }}>Be the first to confirm a place is open tonight.</p>
        </div>
      ) : (
        <ul className="owls-list">
          {entries.map((entry) => (
            <li
              key={entry.handle}
              className={`owl-row${entry.handle.toLowerCase() === myHandle ? " me" : ""}`}
            >
              <span className="owl-rank">{entry.rank}.</span>
              <span className="owl-avatar">{entry.handle.slice(0, 2).toUpperCase()}</span>
              <div className="owl-main">
                <div className="owl-handle">{entry.handle}</div>
                <div className="owl-score">{entry.score} Signals</div>
                {entry.badge && <div className="owl-note">{entry.badge}</div>}
                {entry.handle.toLowerCase() === myHandle && (
                  <span className="owl-self-tag">You&apos;re #{entry.rank}</span>
                )}
              </div>
              <span className="owl-medal">{BADGE_BY_RANK[entry.rank] ?? "🔷"}</span>
            </li>
          ))}
        </ul>
      )}

      <section className="owl-badge-strip" aria-label="Badge track">
        <div className="owl-badge-chip">🌙 Night Owl</div>
        <div className="owl-badge-chip">📍 Explorer</div>
        <div className="owl-badge-chip">🛡 Trusted Scout</div>
      </section>
    </main>
  );
}
